import script from "./ChatPreviewNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatPreviewNew.vue?vue&type=script&lang=ts&setup=true"

import "./ChatPreviewNew.vue?vue&type=style&index=0&id=c28b8d1a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c28b8d1a"]])

export default __exports__